import { createFileRoute, redirect } from "@tanstack/react-router";

// The Merchandising dashboard lives at /user/dashboard; keep the old URL working, query string included.
export const Route = createFileRoute("/_authenticated/user/merchandising/dashboard")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/user/dashboard", search, replace: true });
  },
});
